import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { extractErrorMessage, extractErrorCode } from '../../../utils/apiResponseHandler';
import { Error } from '../../actions/error/error';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/foundation/byomRegister';

function* process(action) {
  try {
    const url = `${config.API_URL}/models/byom/register`;
    const response = yield call(axios.post, url, action.payload, { headers: getLocalUser() });
    yield put(fetchSuccess(response.data?.data || response.data));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure({
      message: extractErrorMessage(error),
      code: extractErrorCode(error),
      // byom_incompatible_segment carries issues/expected layout here.
      details: error?.response?.data?.error?.details,
    }));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, process);
}
